import { render, staticRenderFns } from "./checklistDeleteSubTask.vue?vue&type=template&id=5bb4427d&scoped=true"
import script from "./checklistDeleteSubTask.vue?vue&type=script&lang=ts"
export * from "./checklistDeleteSubTask.vue?vue&type=script&lang=ts"
import style0 from "./checklistDeleteSubTask.vue?vue&type=style&index=0&id=5bb4427d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4427d",
  null
  
)

export default component.exports